module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAQCAYAAADqDXTRAAAA/UlEQVQ4jbWSTU4CQRSEa+GWA3gKA5iIoPyExDtwDm7gCXRHCGKiEJEFLDSeypXu2HwsmAkVMjP0DMxLOpn0q6qvu98IeAJuAJW87oBn4Ersq0xwyziPApa2cV8CsGf5r0Albrxbo39G4IPljuJ9F3yZoHoG4LXlLbx3KFybsHECsGk588N+kuHTDO0CwK75p0maNOPMjL0cwL75Rmm6rIAfC6gFAOumX2ZpjwWFzvjWdLNjBwx5soUFdhL6PsOXgLwgqNj9gXF1U4DjwKxgqIBvA1xGK67MGZ4CFbCKIH/Af/T9ljMjN1TAh91wUsCvC+WvgaRfSRtJwwJ+bQFMAGUjUlrw+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/down-arrow.png
// module id = 266
// module chunks = 0